import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { LegacyBridgeQuery } from '../graphql/LegacyBridgeQuery.graphql.ts';
import type {
	LegacyBridgeQuery as LegacyBridgeQueryType,
	LegacyBridgeQueryVariables,
} from '../__types__/LegacyBridgeQuery.ts';

export async function preloadLegacyBridge({
	contentId,
	isBlog,
}: {
	contentId: string;
	isBlog: boolean;
}) {
	if (!contentId) {
		return;
	}

	return query<LegacyBridgeQueryType, LegacyBridgeQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: LegacyBridgeQuery,
		variables: { contentId, isBlog },
		errorPolicy: 'all',
	});
}
